export const formatFee = (feeString: any) => {
  if (!feeString || typeof feeString !== 'string') return 'N/A';
  if (feeString.includes('-')) {
    const [minFee, maxFee] = feeString.split('-').map((fee) => parseInt(fee.replace(/\D/g, ''), 10));

    if (!Number.isNaN(minFee) && !Number.isNaN(maxFee)) {
      const averageFee = (minFee + maxFee) / 2;
      return `${(averageFee / 1000).toFixed(1)}K`;
    }
  } else {
    const parsedFee = parseInt(feeString?.replace(/\D/g, ''), 10);
    if (!Number.isNaN(parsedFee)) {
      if (feeString.includes('>')) {
        return `Greater than ${(parsedFee / 1000).toFixed(1)}K`;
      } else if (feeString.includes('<')) {
        return `Less than ${(parsedFee / 1000).toFixed(1)}K`;
      } else {
        return `${(parsedFee / 1000).toFixed(1)}K`;
      }
    }
  }

  return 'N/A';
};
